import React from 'react';
import Manage from './Manage';
import { ExtHistoryProvider } from '../../../contexts/extractions/ExtHistoryContext';

const ExtractionsHistory = () => {
    return (
        <ExtHistoryProvider>
            <Manage />
        </ExtHistoryProvider>
    );
};

export default ExtractionsHistory;
